import {
  ERRORS,
  FORCE_RELOAD_PATH_PREFIXES,
  NOTIFIER_UNAUTHORISED_MESSAGE,
  TOKEN_REFRESH_MARGIN_MS,
} from '../constants/constants';

export const isTokenExpired = (auth, now = Date.now()) =>
  !auth || !auth.exp || auth.exp * 1000 <= now;

/**
 * The query the notifier socket connects with. An expired token is left out so the socket connects
 * anonymously: socket.io-client reuses this query on every automatic reconnect, and a tab that has been idle
 * since its token expired would otherwise keep presenting the dead token.
 */
export const buildSocketQuery = (auth, releaseVersion, now = Date.now()) => {
  const query = {source: 'web', version: releaseVersion};
  if (auth && auth.access_token && !isTokenExpired(auth, now)) {
    query.token = auth.access_token;
  }
  return query;
};

/**
 * Milliseconds until the access token should be refreshed, from its exp claim. The token has no expires_in
 * claim, so that cannot be used. Returns undefined when there is no exp to schedule from.
 */
export const tokenRefreshDelay = (auth, now = Date.now()) => {
  if (!auth || !auth.exp) {
    return undefined;
  }
  return Math.max(0, auth.exp * 1000 - now - TOKEN_REFRESH_MARGIN_MS);
};

// socket.io-client 3 passes connect_error an Error; older clients passed a string.
export const isInvalidTokenSocketError = err =>
  err === ERRORS.INVALID_TOKEN ||
  (!!err && err.message === NOTIFIER_UNAUTHORISED_MESSAGE);

// Whether a pending force-reload may run on arriving at this path: the home page or a browsing page.
export const canForceReloadAt = pathname =>
  pathname === '/' ||
  FORCE_RELOAD_PATH_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
